export { default } from './CardImage'
